/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

(function () {
  let a = document.querySelector('a[href="#refer-and-get"]');
  a.addEventListener('click', (e) => {
    e.preventDefault();
    let widget = document.querySelector('#bixgrow-refer-widget-desktop-id');
    widget.click();
  })
})();

(function () {
  document.addEventListener('change', (e) => {
    if (e.target.closest('.product-item__form-options__selector')) {
      let value = e.target.value;
      if (!value) {
        return;
      }

      let form;
      for (form = e.target.parentNode; !form.classList.contains('product-item__form');) {
        form = form.parentNode;
      }

      let productDataRaw = form.querySelector(`#${form.getAttribute('id')}_data`).innerText;
      let productData = JSON.parse(productDataRaw);

      let selectedVariant = null;
      productData.forEach(variant => {
        if (variant.option1 == value) {
          selectedVariant = variant;
        }
      });

      form.querySelector('input[name="id"]').value = selectedVariant.id;

      let productItemInfo;
      for (productItemInfo = form.parentNode; !productItemInfo.classList.contains('product-item__info');) {
        productItemInfo = productItemInfo.parentNode;
      }

      if (productItemInfo) {
        productItemInfo.querySelector('span.price').innerText = formatMoney(selectedVariant.price);
      }

      // Changing image
      let productItem;
      for (productItem = form; !productItem.classList.contains('product-item');) {
        if (productItem.parentNode) {
          productItem = productItem.parentNode;
        }
      }

      if (productItem.classList.contains('product-item')) {
        let sixJarsVariant = productItem.querySelector('.product-item__primary-image.variant-6-jar');
        if (sixJarsVariant) {
          let primaryImg = productItem.querySelector('.product-item__primary-image:not(.variant-6-jar)');
          if (value == '1 Jar') {
            sixJarsVariant.style.display = 'block';
            if (primaryImg) {
              primaryImg.style.display = 'none';
            }
          } else {
            sixJarsVariant.style.display = 'none';
            if (primaryImg) {
              primaryImg.style.display = 'block';
            }
          }
        }
      }

      // Updating the Recharge Widget Price
      let subSaveInput = form.querySelector(".rc_widget__option__input--subsave");
      if (subSaveInput && subSaveInput.checked) {
        let subSaveLabel = form.querySelector('label[data-label-subsave]');
        if (subSaveLabel) {
          subSaveLabel.click();
        }
      } else {
        let onetimeLabel = form.querySelector('label[data-label-onetime]');
        if (onetimeLabel) {
          onetimeLabel.click();
        }
      }
    }
  });
})();

/* RECHARGE WIDGET SCRIPT */
const applyRechargeProductWidget = async () => {
  let productForm = document.querySelectorAll('form.product-item__form'); // [action="/cart/add"]

  productForm.forEach(pf => {
    let rechargeWidgetWrapper = pf.querySelector('.rc-widget-wrapper');

    // Aborting if wrapper is not found.
    if (!rechargeWidgetWrapper) {
      return
    }

    const rechargeConfig = {
      productId: Number(pf.getAttribute("data-productid")),
      injectionParent: `#${pf.getAttribute('id')} .rc-widget-wrapper`,
      injectionMethod: 'prepend',
      selectors: {
        price: ['.price'],
        variant: ['.product-item__form-options__selector', '.product-item__form-options', 'input[name="id"]']
      }
    }

    // Clearing the widget wrapper
    rechargeWidgetWrapper.innerHTML = '';

    // Creating widget with provided configs
    window.ReChargeWidget.createWidget(rechargeConfig);

    pf.setAttribute('data-recharge-loaded', 'true');

    let productItem;
    for (productItem = pf; !productItem.classList.contains('product-item');) {
      if (productItem.parentNode) {
        productItem = productItem.parentNode;
      }
    }

    if (productItem.classList.contains('product-item')) {
      let priceContainer = productItem.querySelector(".product-item-meta__price-list-container");
      if (priceContainer) {
        priceContainer.style.display = 'none';
      }
    }
  });
}

const rechargeWidgetInterval = setInterval(() => {
  if (window.ReChargeWidget) {
    applyRechargeProductWidget();
    clearInterval(rechargeWidgetInterval);
  }
}, 100);